import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-deviation-types',
  templateUrl: './deviation-types.component.html',
  styleUrls: ['./deviation-types.component.css']
})
export class DeviationTypesComponent implements OnInit {
    activityTypeNo;

    public setting?: Setting;

    public itemsListDeviationTypes: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.activityTypeNo = this.stateService.getStateParams()['activitytype_no'];
    }

    private async loadSetting() {
        if (!!this.activityTypeNo) {
            this.setting = (await this.datatask.Post(1227, { activitytype_no: this.activityTypeNo }))[0];
        }
    }

    private async loadDeviationTypes() {
        if (!this.setting) return;

        return this.itemsListDeviationTypes = await this.datatask.Post(43, {
            isactive: 'ALL',
            activitytype_no: this.setting.activitytype_no
        });
    }

    public onChanged(_: string, id: keyof Setting) {
        if (!this.setting) return;

        switch (id) {
            case 'show_all':
                if (this.setting.show_all === '1') {
                    this.setting.activitytype_no = '0';

                    this.loadDeviationTypes();
                } else {
                    this.setting.activitytype_no = this.activityTypeNo;

                    this.loadDeviationTypes();
                }
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadDeviationTypes();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    activitytype_no: string;
    page_heading: string;
    show_all: string;
}
